const typography = {
  fontFamily: ['Acronym-Regular', 'sans-serif'].join(','),
  h1: {
    fontSize: '57px',
    fontWeight: 400,
  },
  h2: {
    marginBottom: '20px',
    fontSize: '1.3rem',
    fontWeight: 700,
  },
  h6: {
    fontSize: '1rem',
    fontWeight: 700,
  },
  subtitle1: {
    fontSize: '1rem',
  },
  button: {
    fontWeight: 700,
    letterSpacing: '0.02857em',
  },
}

export default typography
